// react
import React from "react";
import { FormattedMessage } from 'react-intl';

// application
import SocialLinks from "../shared/SocialLinks";

export default function FooterNewsletter() {
    return (
        <div className="site-footer__widget footer-newsletter">
            <h5 className="footer-newsletter__title">
                <FormattedMessage id="footer.newsletter" defaultMessage="Newsletter" />
            </h5>
            <SocialLinks className="footer-newsletter__social-links" shape="circle" />
        </div>
    );
}
